module.exports = __webpack_public_path__ + "img/atu.e4c834cd.jpg";